import React from 'react';
import { FilePreviewer } from 'react-file-utils';
import * as Sentry from '@sentry/browser';

import { attachmentPreviewPropTypes } from '../../../../utils/attachments';
import { downloadUrlAsFile } from '../../../../../utils/file';
import { FilePreviewContainer } from './styles';

const FileMessageAttachment = ({
  assetLocalUrl,
  attachmentData: {
    title,
    mimeType,
    fileSize,
  },
}) => {
  const handleDownload = async (event) => {
    event.preventDefault();
    try {
      await downloadUrlAsFile(assetLocalUrl, title);
    } catch (error) {
      Sentry.captureException(error, {
        extra: {
          assetLocalUrl,
        },
      });
    }
  };

  return (
    <FilePreviewContainer onClick={handleDownload}>
      <FilePreviewer
        uploads={[{
          url: assetLocalUrl,
          file: {
            name: title,
            type: mimeType,
            size: fileSize,
          },
        }]}
      />
    </FilePreviewContainer>
  );
};

FileMessageAttachment.propTypes = attachmentPreviewPropTypes;

FileMessageAttachment.defaultProps = {};

export default FileMessageAttachment;
